import { render, staticRenderFns } from "./ScheduleCalendar.vue?vue&type=template&id=4452d5aa&scoped=true&"
import script from "./ScheduleCalendar.vue?vue&type=script&lang=js&"
export * from "./ScheduleCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleCalendar.vue?vue&type=style&index=0&id=4452d5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452d5aa",
  null
  
)

export default component.exports